// extracted by mini-css-extract-plugin
module.exports = {"observer":"InfiniteScroll_observer__MsTDM","parent":"InfiniteScroll_parent__7o4sX"};